export const enLogin = {
	signInToSignalist: "Sign in to Signalist.io",
	dontHaveAccount: "Don't have an account yet? ",
	signUpForFree: "Sign up for free",
	welcomeBack: "Welcome back",
	emailPlaceholder: "Your e-mail address",
	forgotPasswordCta: "Forgot Password?",
	loginCta: "Login",
	passwordPlaceholder: "Your password",
	title: "Log in",
	invalidData: "Email or password is wrong",
	passwordNotSet:
		"You haven't set a password yet. Use the invite link we emailed you, or reset your password.",
};
